import { settings } from "../../app";
import {
  setTokens,
  getAccessToken,
  getRefreshToken,
  removeTokens,
  setPermissions,
  getPermissions,
  accessResponseString,
  refreshResponseString,
  userProfileString,
  userNameString,
  passwordString,
  recaptchaString,
  passwordChangeRequiredString,
  removeUser,
} from "./securityUtils";

const fetchPermissions = () => {
  const request = new Request(`${settings.authorizationApi}/authentication/permissions`, {
    headers: new Headers({
      Authorization: `Session ${getAccessToken()}`,
    }),
  });
  return fetch(request)
    .then(res => res.json())
    .then(data => {
      setPermissions(JSON.stringify(data));
    });
};

const authProvider = {
  login: ({ username, password, recaptcha, changePasswordCallback }) => {
    let body = {};
    body[userNameString] = username;
    body[passwordString] = password;
    if (recaptcha) body[recaptchaString] = recaptcha;
  

    const request = new Request(`${settings.authorizationApi}/authentication/${settings.loginEndpoint || "login"}`, {
      method: "POST",
      body: JSON.stringify(body),
      headers: new Headers({ "Content-Type": "application/json" }),
    });
    return fetch(request)
      .then(response => {
        if (response.status < 200 || response.status >= 300) {
          return Promise.reject();
        }
        return response.json();
      })
      .then(async auth => {
        if (auth[accessResponseString]) {
          setTokens(auth[accessResponseString], auth[refreshResponseString]);
          if (settings.usesSeparatePermissions) {
            await fetchPermissions();
          } else {
            setPermissions(JSON.stringify({ isAdmin: true }));
          }
        }
        if (auth[passwordChangeRequiredString] && changePasswordCallback) {
          changePasswordCallback({ ...auth, username });
        }
        if (auth[userProfileString]) localStorage.setItem(userProfileString, JSON.stringify(auth[userProfileString]));

        return Promise.resolve(auth);
      })
      .catch(() => {
        return Promise.reject();
      });
  },

  checkError: params => {
    if (
      params.ok === false &&
      (params.url.includes("authentication/refresh") ||
        params.url.includes(`authentication/${settings.loginEndpoint || "login"}`))
    ) {
      return Promise.reject();
    }
    return Promise.resolve();
  },

  checkAuth: () => {
    return getAccessToken() || getRefreshToken() ? Promise.resolve() : Promise.reject();
  },

  logout: () => {
    removeTokens();
    removeUser();

    return Promise.resolve();
  },

  // getIdentity: () => Promise.resolve(),

  getPermissions: () => {
    return Promise.resolve(getPermissions());
  },
};

export default authProvider;
